import React, {
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';

import runTask from '../../../utils/api_functions/taskCreation';

import useWorkspaceContext from '../../workspaces/WorkspaceContext/WorkspaceContext';

const TaskCreationContext = React.createContext({
  loading: false,
  error: null,
  onCreate: () => {},
});

export const TaskCreationContextProvider = ({ orchestrationId, onClose, children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { currentWorkspaceId } = useWorkspaceContext();

  const handleCreation = useCallback(({
    taskName, taskType, schedule, timeout, jsonStr,
  }) => {
    if (orchestrationId && currentWorkspaceId >= 0 && taskName && taskType ) {
      setLoading(true);
      runTask({
        taskName,
        taskType,
        orchestrationId,
        workspaceId: currentWorkspaceId,
        schedule,
        timeout,
        jsonStr
      }).then(() => {
        setLoading(false);
        setError(null);
        onClose();
      }).catch(() => {
        setLoading(false);
        setError('Something when wrong during task creation. Please try again in a little while.')
      })
    } else {
      setLoading(false);
      setError('Something when wrong during task creation. Please try again in a little while.')
    }
  }, [orchestrationId, currentWorkspaceId, onClose]);

  const contextValue = useMemo(() => ({
    loading, error, onCreate: handleCreation,
  }), [loading, error, handleCreation])
  return (
    <TaskCreationContext.Provider
      value={contextValue}
    >
      { children }
    </TaskCreationContext.Provider>
  )
};

export const useTaskCreation = () => useContext(TaskCreationContext)

export default useTaskCreation;
